export default "__VITE_ASSET__BbK6E7h3__"